/**
 * "Essential = Timeless" landing — compare slider (sections/essential-timeless-landing.liquid).
 *
 * <et-compare> wraps two stacked product photos; a full-size, invisible <input type="range">
 * sits on top so dragging anywhere (mouse, touch, keyboard arrows) moves the split. The value
 * is written to the --et-split custom property, which the CSS uses for the clip-path of the
 * right-hand image and the position of the handle. Nothing else is animated.
 */
(() => {
  if (customElements.get('et-compare')) return;

  class EtCompare extends HTMLElement {
    connectedCallback() {
      if (this._initialised) return;
      this._initialised = true;
      this.range = this.querySelector('[data-et-range]');
      if (!this.range) return;
      this.onInput = this.onInput.bind(this);
      this.range.addEventListener('input', this.onInput);
      this.range.addEventListener('change', this.onInput);
      this.render(Number(this.range.value));
    }

    onInput() {
      this.classList.add('is-touched');
      this.render(Number(this.range.value));
    }

    render(value) {
      const split = Math.min(100, Math.max(0, Number.isFinite(value) ? value : 50));
      this.style.setProperty('--et-split', `${split}%`);
      const labelA = this.dataset.labelA || '';
      const labelB = this.dataset.labelB || '';
      this.range.setAttribute('aria-valuetext', `${split}% ${labelA}, ${100 - split}% ${labelB}`);
    }
  }

  customElements.define('et-compare', EtCompare);
})();
